import React from 'react';
import PropTypes from 'prop-types';
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineCreditCard,
  MdOutlineQrCode2,
} from 'react-icons/md';
import { IoIosCard } from 'react-icons/io';
import { PiBankBold } from 'react-icons/pi';
import { FiCreditCard } from 'react-icons/fi';
import AppPaymentGatewaySelector from '../../../../shared/components/app-payment-gateway-selector/AppPaymentGatewaySelector';
import { PAYMENT_MODES, WALLET_MODE } from '../../constants/packageConstants';
import './PackagePaymentModes.scss';

const ICONS = {
  cashcard: <MdOutlineAccountBalanceWallet />,
  creditcard: <MdOutlineCreditCard />,
  debitcard: <IoIosCard />,
  netbanking: <PiBankBold />,
  upi: <MdOutlineQrCode2 />,
};

/**
 * Wallet / card / net banking / UPI, as on the eSIM and visa booking pages.
 * For any mode other than wallet the shared gateway selector lists the
 * gateways configured for that mode and picks the first one by default.
 */
function PackagePaymentModes({ mode, onModeChange, pg, onPgChange, error }) {
  return (
    <section className="pkg-payment">
      <header className="pkg-payment__head">
        <span className="pkg-booking__badge">
          <FiCreditCard /> Payment Method
        </span>
      </header>
      <div
        className="pkg-payment__modes"
        role="radiogroup"
        aria-label="Payment method"
      >
        {PAYMENT_MODES.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={mode === key}
            className={`pkg-payment__mode ${
              mode === key ? 'pkg-payment__mode--active' : ''
            }`}
            onClick={() => onModeChange(key)}
          >
            <span className="pkg-payment__icon">{ICONS[key]}</span>
            <span className="pkg-payment__label">{label}</span>
          </button>
        ))}
      </div>
      {mode !== WALLET_MODE && (
        <div className="pkg-payment__gateways">
          <AppPaymentGatewaySelector
            paymentModeClicked={mode}
            selectedPgForPaymentMode={pg}
            onPgSelect={onPgChange}
          />
        </div>
      )}
      <p className="pkg-payment__hint">
        {mode === WALLET_MODE
          ? 'The amount is debited from your agency wallet when you confirm.'
          : 'You will be taken to the payment gateway to pay. The booking is confirmed once the payment succeeds.'}
      </p>
      {error && <span className="pkg-field-error">{error}</span>}
    </section>
  );
}

PackagePaymentModes.propTypes = {
  mode: PropTypes.string.isRequired,
  onModeChange: PropTypes.func.isRequired,
  pg: PropTypes.string.isRequired,
  onPgChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

PackagePaymentModes.defaultProps = {
  error: '',
};

export default PackagePaymentModes;
